var scope_0 = require('/home/runner/work/smile-craft-dental-studios/smile-craft-dental-studios/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8197d59542199ab6a49bc1db79bfabbe.js').default;
var scope_1 = require('/home/runner/work/smile-craft-dental-studios/smile-craft-dental-studios/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/85757cf51cdc67ec5febb6c1c7eb0cb9.js').default;
var scope_2 = require('/home/runner/work/smile-craft-dental-studios/smile-craft-dental-studios/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    